import { pdf } from '@react-pdf/renderer'
import React from 'react'
import { Certification } from '../../types/certification'
import MyDocument from '../../components/pdf-generator'
import { User } from '../../types/user'

function sanitizeFilename(s: string) {
  // Remplace les caractères interdits (pas d'escape inutile pour '/')
  return s.replace(/[/\\?%*:|"<>]/g, '_').trim()
}
// eslint-disable-next-line
const S = (v: any) => (v == null ? '' : String(v))

const DownloadPdf = async (
  DownloadStatus: (
    text: string,
    status: 'success' | 'pending' | 'error'
  ) => void,
  certificationId: string | undefined,
  connectedUser: User | undefined
): Promise<void> => {
  try {
    if (!certificationId || !connectedUser) {
      DownloadStatus('حدث خطأ عند تحميل الشهادة، حاول مجددا لاحقا', 'error')
      return
    }

    const certification =
      connectedUser.certifications?.find(
        (c: Certification) => c.id === certificationId
      ) || null

    if (!certification) {
      DownloadStatus('حدث خطأ عند تحميل الشهادة، حاول مجددا لاحقا', 'error')
      return
    }

    DownloadStatus(
      `جارٍ تحميل شهادة ${certification.training.title}`,
      'pending'
    )

    // Génération du PDF
    const blob = await pdf(
      <MyDocument connectedUser={connectedUser} certification={certification} />
    ).toBlob()

    if (!blob || blob.size === 0) {
      throw new Error('Empty PDF blob')
    }

    const url = window.URL.createObjectURL(blob)

    // Nom de fichier propre
    const fileName = `${sanitizeFilename(
      `${S(certification.training.title)} - 
       ${S(connectedUser.lastName ?? '')} 
       ${S(connectedUser.firstName ?? '')}`.trim()
    )}.pdf`

    // Création d'un lien dans le DOM (compat Safari/Firefox)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url

    // Fallback si l'attribut "download" n'est pas supporté (vieux iOS Safari)
    if (typeof (a as HTMLAnchorElement).download === 'undefined') {
      window.open(url, '_blank')
    } else {
      a.setAttribute('download', fileName)
      document.body.appendChild(a)
      a.click()
      // Laisse le téléchargement démarrer, puis nettoyage
      setTimeout(() => {
        if (a.parentNode) a.parentNode.removeChild(a)
        window.URL.revokeObjectURL(url)
      }, 1500)
    }

    DownloadStatus(
      `تم تحميل شهادة ${certification.training.title} بنجاح`,
      'success'
    )
  } catch (e) {
    // eslint-disable-next-line
    console.error('[DownloadPdf] error', e)
    DownloadStatus('حدث خطأ عند تحميل الشهادة، حاول مجددا لاحقا', 'error')
  }
}

export default DownloadPdf
